import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class WindowProvider {

    getLocationOrigin(): string {
        return window.location.origin
    }

    navigateToUrl(url: string) {
        window.location.href = url
    }

    openWindowAtUrl(url: string): Window | null {
        return window.open(url, '_blank')
    }
}
